import * as React from "react";
import { ReactSVG } from 'react-svg';
//import SyncLoader from 'react-spinners/SyncLoader';

const QrImage = (props) => {
    const { beforeClass, className, onClick, src, cache, wrapper, ariaLabel } = props;

    return (
        <ReactSVG
            beforeInjection={(svg) => {
                svg.classList.add(beforeClass)
            }}
            className={className}
            evalScripts="always"
            fallback={() => <span className="text-danger">Erro!</span>}
            httpRequestWithCredentials={true}
            //loading={() => <SyncLoader size={16} color="#fdc436" />}
            onClick={onClick}
            renumerateIRIElements={false}
            src={src}
            useRequestCache={cache} // true / false
            wrapper={wrapper} // tag html
            aria-label={ariaLabel}
        />
    )
}

export default QrImage;